import axios from "axios";
import config from "../config";

export function updatePresence(body) {
  return axios.put(`${config.api_url}/presence`, body);
}
